import Timer from '@/_application/core/components/ui/timer';
import TimerProgress from '@/_application/core/components/ui/timer-progress';
import {getBasePrice} from '@/_application/modules/products/model/price';
import {Product} from '@/_application/modules/products/model/product';
import {calculateDiscountPercentage} from '@/lib/price-utils';
import usePrice from '@/lib/use-price';
import {useTranslation} from 'next-i18next';
import {FlashSaleProductData} from '@/__generated__/__types__';

interface Props {
    product: Product;
    flashSaleData: FlashSaleProductData;
}

function ProductDetailsFlashSale({product, flashSaleData}: Readonly<Props>) {
    const {t} = useTranslation();

    const dealPriceSale = flashSaleData?.deal_price;
    const basePriceSale = getBasePrice(product);
    const {price: dealPrice} = usePrice({
        amount: dealPriceSale!,
        currencyCode: 'VND',
    });
    const {price: basePrice} = usePrice({
        amount: basePriceSale.value!,
        currencyCode: basePriceSale.currency ?? 'VND',
    });

    const discountPercentage = calculateDiscountPercentage(basePrice ?? '', dealPrice ?? '');
    return (
        <div className="min-h-[54px] w-full md:min-h-fit bg-gradient-orange md:rounded-[5px]">
            <div className="w-full px-3.5 py-[5px] md:rounded-md">
                <div className="flex w-full items-center justify-between">
                    <div className="flex flex-col">
                        <span className="text-xl font-bold text-white">{dealPrice}</span>
                        <div className="flex items-center gap-1.5">
                            <span className="text-xs font-medium text-white line-through">{basePrice}</span>
                            <span className="rounded-full bg-KPZ_Yellow px-1.5 text-center text-[0.625rem] font-bold text-KPZ_red">
                                {discountPercentage ? `-${discountPercentage}%` : ''}
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex items-start">
                            <div className="flex w-[90px] flex-col">
                                <span className="text-[10px] uppercase text-white">{t('text-end-in')}:</span>
                                <TimerProgress
                                    dateFrom={flashSaleData?.date_from ?? ''}
                                    dateTo={flashSaleData?.date_to ?? ''}
                                    timeInterval={5000}
                                />
                            </div>
                        </div>
                        <Timer
                            dateTo={flashSaleData?.date_to ?? ''}
                            className="items-center gap-1 text-xs font-bold text-white"
                            elementClassName="rounded-md border-2 border-white px-1 py-0.5"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductDetailsFlashSale;
